import { UpgradeComponent } from "@angular/upgrade/static";
import { Directive, ElementRef, Injector, Input } from "@angular/core";
import { IPromise, IQService, IScope } from "angular";
import { LogWithData } from "ng/src/app/logs/log.model";
import { Template, TemplateSegment } from '../../templates/shared/template.model';
import { Report } from "ng/src/app/reports/report.model";

@Directive({
	selector: 'lb-alert-trigger-builder-upgrade[onBind][selectedLog][template][report]',
})
export class AlertTriggerBuilderUpgradeComponent extends UpgradeComponent {
	@Input() onBind!: (scope: AlertTriggerBuilderScope) => void;
	@Input() selectedLog!: LogWithData;
	@Input() template!: Template;
	@Input() report!: Report;
	
	constructor(
		injector: Injector,
		elRef: ElementRef
	) {
		super('alertTriggerBuilder', elRef, injector);
	}
}

export interface AlertTriggerBuilderScope extends IScope {
	saveAll(): IPromise<any>
	saveReport(): IPromise<any>
	getTemplateSegments(): IPromise<TemplateSegment[]>
	getTriggerSaveStatus(): IPromise<boolean>
	alertTriggerContainer: {
		scope?: IScope,
		defer: IQService,
		bound(containerScope: IScope): void,
		promise: IPromise<IScope>
	}
}